import classnames from 'classnames';
import React from 'react';
import styles from './filtersSkeleton.module.css';

type Props = {
  isMobile?: boolean;
};

const EmptyFilterItem = ({ isMobile }: Props) => (
  <div
    className={classnames(styles.emptyFilterItemContainer, {
      [styles.emptyFilterItemContainerDesktop]: !isMobile,
      [styles.emptyFilterItemContainerMobile]: isMobile,
    })}
  >
    <span
      className={classnames(styles.emptyFilterCheckbox, {
        [styles.emptyFilterCheckboxMobile]: isMobile,
        [styles.emptyFilterCheckboxDesktop]: !isMobile,
      })}
    />
    <div
      className={classnames(styles.emptyFilterLabel, {
        [styles.emptyFilterLabelMobile]: isMobile,
      })}
    />
  </div>
);
const EmptyFilter = ({ isMobile }: Props) => (
  <div
    className={classnames({
      [styles.emptyFilterContainerDesktop]: !isMobile,
      [styles.emptyFilterContainerMobile]: isMobile,
    })}
  >
    <div className={styles.emptyFilterHeader} />
    {Array(3)
      .fill(null)
      .map((unused, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <EmptyFilterItem key={idx} isMobile={isMobile} />
      ))}
  </div>
);

const FiltersSkeleton = ({ isMobile }: Props) => (
  <div className="filters">
    {Array(7)
      .fill(null)
      .map((_unused, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <EmptyFilter key={idx} isMobile={isMobile} />
      ))}
  </div>
);

export default FiltersSkeleton;
